import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import publicRoutes from './PublicRoutes';
import protectedRoutes from './ProtectedRoutes';

const ERROR_NOT_FOUND_MESSAGE =
  'Sorry, but the page you are looking for does not exist,' +
  ' the name is changed or temporarily unavailable.';

export const routes: RouteObject[] = [
  ...publicRoutes,
  ...protectedRoutes,
  {
    path: '*',
    element: (
      <Navigate
        replace={true}
        to={`/error?message=${ERROR_NOT_FOUND_MESSAGE}`}
      />
    ),
  },
];

export default function ReactRoutes() {
  return <Outlet />;
}
